module.exports = __webpack_public_path__ + "img/Dorado.3d8655a3.png";